// Modul zur Zurordnung einer Terminreihe zum Antrag
"use strict";

import module from "./module.js";

export default module;
